import { cn } from "@universe/ui/lib/utils";
import { ArrowDown, ArrowUp, Minus, Repeat } from "lucide-react";

import { JournalType } from "./types";

type LedgerDirectionIconProps = {
  balance: number;
  journalType: JournalType;
  isFee?: boolean;
  className?: string;
};

export default function LedgerDirectionIcon({
  balance,
  journalType,
  isFee,
  className,
}: LedgerDirectionIconProps) {
  if (journalType === JournalType.FX_TICKETS) {
    return (
      <div>
        <Repeat
          strokeWidth={2}
          className={cn(
            "text-primary w-6 h-6 -translate-x-0.5 scale-90",
            className
          )}
        />
      </div>
    );
  }

  if (isFee) {
    return (
      <div>
        <Minus
          strokeWidth={2}
          className={cn("text-primary w-6 h-6", className)}
        />
      </div>
    );
  }

  const isCredit = balance > 0;

  return (
    <div>
      {isCredit ? (
        <ArrowDown
          strokeWidth={2}
          className={cn("text-green-600 w-6 h-6 scale-105", className)}
        />
      ) : (
        <ArrowUp
          strokeWidth={2}
          className={cn("text-red-600 w-6 h-6 scale-105", className)}
        />
      )}
    </div>
  );
}
